import { useEffect } from "react";
import { Callout } from "../../components/Callout";
import { WalletMissingSheet } from "../../components/WalletMissingSheet";
import { useConfig } from "../../hooks/useConfig";
import { CLAIM_GAS, INDEXSY_MINT } from "../../lib/facts";
import { Link } from "../../router/router";
import { PhaseBanner } from "./PhaseBanner";
import { StepClaim } from "./StepClaim";
import { StepEligibility } from "./StepEligibility";
import { StepRegister } from "./StepRegister";
import { useAirdropFlow } from "./useAirdropFlow";

export function AirdropPage() {
  const flow = useAirdropFlow();
  const { config, error, loading } = useConfig();
  const takenAt = config?.snapshot.takenAt ?? null;

  useEffect(() => {
    document.title = "Airdrop | $TISM";
  }, []);

  return (
    <>
      <section className="shell section">
        <div className="stack stack-5">
          <PhaseBanner />
          <h1>Airdrop</h1>
          <p className="lede">
            The top 200 $INDEXSY holders at the snapshot can claim $TISM. Prove the Solana wallet
            with Phantom, register an address with MetaMask, then claim on Robinhood Chain.
          </p>
          <p className="body">
            The airdrop is free. There is nothing to do except prove the wallet and register an
            address. No tasks, no posting, no referrals. Claiming costs you {CLAIM_GAS} in gas on
            Robinhood Chain.
          </p>
          <p className="small">
            {takenAt
              ? `The snapshot was taken on ${takenAt}, before any announcement of the airdrop.`
              : "The snapshot was taken before any announcement of the airdrop. Its date is published before registration opens."}
          </p>
          <p className="small">
            $INDEXSY is a Solana token. Its mint is{" "}
            <span className="mono">{INDEXSY_MINT}</span>. Two impostor tokens use the same ticker,
            so check the mint before you compare balances.
          </p>
          <p className="small">
            Nobody from this project will message you first, and nobody will ever ask for a seed
            phrase. This site is the only official channel. Read the <Link to="/faq">FAQ</Link> if
            anything looks off.
          </p>
          {error && !loading ? (
            <Callout tone="error" role="alert">
              Could not load the airdrop settings. Reload the page and try again.
            </Callout>
          ) : null}
        </div>
      </section>

      <section className="shell section--tight" style={{ paddingBottom: "var(--section-y)" }}>
        <div className="stack stack-6">
          <StepEligibility flow={flow} />
          <StepRegister flow={flow} />
          <StepClaim flow={flow} />
        </div>
      </section>

      <WalletMissingSheet
        wallet={flow.missingWallet}
        onClose={() => flow.setMissingWallet(null)}
      />
    </>
  );
}
